var _ellipse, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 65,
    viewBox: "0 0 66 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.9114,
    cy: 32.5,
    rx: 32.2166,
    ry: 32.5,
    fill: "#002323"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5652 21.4402L25.6752 19.5335C22.5031 21.9735 20.4148 25.7335 20.2297 30.0002H22.8731C23.0714 26.4668 24.8689 23.3735 27.5652 21.4402V21.4402ZM43.9411 30.0002H46.5845C46.3863 25.7335 44.298 21.9735 41.1391 19.5335L39.2623 21.4402C41.9321 23.3735 43.7429 26.4668 43.9411 30.0002ZM41.3374 30.6668C41.3374 26.5735 39.1698 23.1468 35.3897 22.2402V21.3335C35.3897 20.2268 34.5042 19.3335 33.4071 19.3335C32.3101 19.3335 31.4246 20.2268 31.4246 21.3335V22.2402C27.6313 23.1468 25.4769 26.5602 25.4769 30.6668V37.3335L22.8335 40.0002V41.3335H43.9808V40.0002L41.3374 37.3335V30.6668ZM33.4071 45.3335C33.5922 45.3335 33.764 45.3202 33.9358 45.2802C34.7949 45.0935 35.4954 44.5068 35.8391 43.7068C35.9712 43.3868 36.0373 43.0402 36.0373 42.6668H30.7505C30.7637 44.1335 31.94 45.3335 33.4071 45.3335Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationCircle);
export default __webpack_public_path__ + "static/media/notification-circle.5a94c1346f6c726e44dcf8612fe73d19.svg";
export { ForwardRef as ReactComponent };